import { render, staticRenderFns } from "./SuspendedVehicles.html?vue&type=template&id=fb3bf0f0&scoped=true&external"
import script from "./SuspendedVehicles.js?vue&type=script&lang=js&external"
export * from "./SuspendedVehicles.js?vue&type=script&lang=js&external"
import style0 from "./SuspendedVehicles.vue?vue&type=style&index=0&id=fb3bf0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3bf0f0",
  null
  
)

export default component.exports